<template>
  <div class="box">
    <h2>Advisory Board Memberships</h2>

    <table class="table b-table table-bordered table-hover">
      <thead class="thead-light">
        <tr>
          <th>Name</th>
          <th>Current Project</th>
          <th>Role</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="boards.length === 0">
          <td class="text-center" colspan="4">
            <em class="text-muted">Not on any advisory boards yet!</em>
          </td>
        </tr>

        <tr v-for="board in boards" :key="board.uuid">
          <td>
            <router-link :to="`/user/${board.user.uuid}`">
              <img
                class="rounded-circle img-profile mr-2"
                :src="board.user.avatar"
              >
              {{ board.user.first_name }} {{ board.user.last_name }}
            </router-link>
          </td>

          <td>{{ board.user.company_name }}</td>

          <td>{{ board.user.company_role }}</td>

          <td>
            <div v-if="board.status === 'pending'">
              <b-btn
                class="mr-3" variant="secondary" size="sm"
                @click="accept(board.uuid)"
              >
                Accept Invitation
              </b-btn>

              <b-btn
                variant="danger" size="sm"
                @click="leave(board.uuid)"
              >
                Decline
              </b-btn>
            </div>

            <div v-if="board.status === 'approved'">
              <b-btn
                class="mr-3" variant="primary" size="sm"
                @click="openModal(board.user)"
              >
                Book Meeting
              </b-btn>

              <b-btn
                variant="danger" size="sm"
                @click="leave(board.uuid)"
              >
                Leave Board
              </b-btn>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <schedule-modal
      :show="showScheduleModal" :user="user"
      @dismiss="showScheduleModal = false"
    />
  </div>
</template>

<script>
import ScheduleModal from '@/components/advisors/ScheduleModal'

export default {
  name: 'AdvisoryMembership',
  components: {
    ScheduleModal
  },
  data () {
    return {
      loading: false,
      boards: [],
      user: null,
      showScheduleModal: false,
      areas: {
        finance: 'Finance',
        legal: 'Legal',
        hr: 'HR',
        strategy: 'Strategy',
        ops: 'Ops',
        tech: 'Tech',
        sales: 'Mktg/Sales',
        buySell: 'Buy/Sell',
        franchising: 'Franch',
        international: 'Intl',
        government: 'Govt'
      }
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true

      this.$http
        .get('advisory_board/boards')
        .then(
          (res) => {
            this.boards = res.data.data
          },
          () => {}
        )
        .finally(() => {
          this.loading = false
        })
    },
    accept (uuid) {
      this.$http
        .post(`advisory_board/accept/${uuid}`)
        .finally(this.load)
    },
    leave (uuid) {
      this.$bvModal.msgBoxConfirm(
        'Are you sure you want to leave this advisory board?',
        {
          title: 'Leave Group',
          centered: true
        }
      )
        .then(value => {
          if (!value) {
            return
          }

          this.$http
            .post(`advisory_board/decline/${uuid}`)
            .finally(this.load)
        })
    },
    openModal (user) {
      this.user = user
      this.showScheduleModal = true
    }
  }
}
</script>

<style scoped>
.img-profile { width: 24px; height: 24px; }
</style>
